import type { AdministrationContentPage } from "@kontextwerk/control-web-frame/shared/logic/administration"

export const pageConfig: AdministrationContentPage = {
  id: "whatsapp",
  title: "WhatsApp-Vorlagen",
  path: "whatsapp",
  tabs: [
    ["announcement", "Ankündigung"],
    ["reschedule", "Verschiebung"],
  ].map(([purpose, title]) => ({
    id: `whatsapp-${purpose}`,
    title,
    routeSegment: purpose.replaceAll("_", "-"),
    widthType: "normal",
    testId: `controlAdmin.organizationView.announcementTemplates.whatsapp.${purpose}`,
  })),
}
